import {
	Breadcrumbs as MatBreadcrumbs,
} from '@material-ui/core';
import styled from 'styled-components';

export const UiBreadcrumbs = styled(MatBreadcrumbs)`
	display: flex;
	padding-bottom: 1rem;
`;
